import { Component, OnChanges, inject, input, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { LocalizationService } from '../../../core/localization/localization.service';
import { WorkflowRetryPolicyConfig } from '../workflow-catalog.models';

@Component({
  standalone: true,
  selector: 'ain-workflow-retry-policy-form',
  imports: [FormsModule, InputTextModule],
  template: `
    <div class="retry-grid">
      <label>{{ t('workflow.designer.operators.retry.maxAttempts') }}</label>
      <input pInputText type="number" min="1" max="10" [(ngModel)]="maxAttempts" (ngModelChange)="emitChange()" />

      <label>{{ t('workflow.designer.operators.retry.backoffSeconds') }}</label>
      <input pInputText [(ngModel)]="backoffText" (ngModelChange)="emitChange()" [placeholder]="t('workflow.designer.operators.retry.backoffPlaceholder')" />
    </div>
  `,
  styles: [`
    .retry-grid { display: grid; grid-template-columns: 1fr; gap: 6px; }
    .retry-grid label { font-size: 12px; color: #475569; }
  `]
})
export class WorkflowRetryPolicyFormComponent implements OnChanges {
  private readonly localization = inject(LocalizationService);

  readonly retryPolicy = input<WorkflowRetryPolicyConfig | undefined>(undefined);
  readonly retryPolicyChange = output<WorkflowRetryPolicyConfig | undefined>();

  maxAttempts = 1;
  backoffText = '';

  ngOnChanges(): void {
    const policy = this.retryPolicy();
    this.maxAttempts = policy?.maxAttempts ?? 1;
    this.backoffText = (policy?.backoffSeconds ?? []).join(', ');
  }

  emitChange(): void {
    const backoffSeconds = this.backoffText
      .split(',')
      .map(item => Number.parseInt(item.trim(), 10))
      .filter(item => Number.isFinite(item) && item >= 0);

    const maxAttempts = Math.min(10, Math.max(1, this.maxAttempts || 1));
    if (maxAttempts <= 1 && backoffSeconds.length === 0) {
      this.retryPolicyChange.emit(undefined);
      return;
    }

    this.retryPolicyChange.emit({
      maxAttempts,
      backoffSeconds: backoffSeconds.length > 0 ? backoffSeconds : undefined
    });
  }

  t(key: string): string {
    return this.localization.translate(key);
  }
}
